import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useField, useFormikContext } from "formik";

const DateStrPicker = React.forwardRef(function DateStrPicker(props, ref) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker']}>
        <DatePicker
          {...field}
          {...props}
          selected={(field.value && new Date(field.value)) || null}
          onChange={val => {
              setFieldValue(field.name, val);
          }}
        ></DatePicker>
      </DemoContainer>
    </LocalizationProvider>
  );
});

export default DateStrPicker;